export const legalPages = {
  privacy: {
    slug: "privacy",
    navLabel: "Privacy Policy",
    title: "Privacy Policy",
    eyebrow: "Your data, clearly explained",
    description: "How Koineckta collects, uses, protects, and manages personal data across its services.",
    version: "1.0",
    effectiveDate: "24 August 2026",
    updatedDate: "24 August 2026",
    contentUrl: "/legal/privacy.md",
    downloadUrl: "/legal/Koineckta_Privacy_Policy_v1.0.docx",
  },
  terms: {
    slug: "terms",
    navLabel: "Terms",
    title: "Terms of Service",
    eyebrow: "The terms that govern our services",
    description: "The rules, responsibilities, and conditions that apply when accessing or using Koineckta services.",
    version: "1.0",
    effectiveDate: "24 August 2026",
    updatedDate: "24 August 2026",
    contentUrl: "/legal/terms.md",
    downloadUrl: "/legal/Koineckta_Terms_of_Service_v1.0.docx",
  },
  disclaimer: {
    slug: "disclaimer",
    navLabel: "Disclaimer",
    title: "Website & Product Disclaimer",
    eyebrow: "Important product and risk information",
    description: "Important context about Koineckta’s services, digital-asset risks, third parties, and service availability.",
    version: "1.0",
    effectiveDate: "24 August 2026",
    updatedDate: "24 August 2026",
    contentUrl: "/legal/disclaimer.md",
    downloadUrl: "/legal/Koineckta_Website_and_Product_Disclaimer_v1.0.docx",
  },
};

export const legalPageList = Object.values(legalPages);